import { rem } from "polished";
import styled from "styled-components";

export const Label = styled.label`
  display: grid;
  grid-template-columns: max-content 1fr ${rem(16)};
  align-items: center;
  gap: ${rem(16)};
  padding: ${rem(16)};
  cursor: pointer;
  box-shadow: inset 0 -1px 0 var(--color-gray-200);

  &:last-child {
    margin-bottom: ${rem(16)};
  }
`;

export const Description = styled.p`
  display: block;
  align-items: center;
  text-align: center;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  gap: ${rem(16)};
  padding: ${rem(16)} 0;
`;

export const CircleImage = styled.img`
  height: ${rem(32)};
  width: ${rem(32)};
  object-fit: cover;
  border-radius: 50%;
`;

export const StandardImage = styled.img`
  height: ${rem(32)};
  width: ${rem(32)};
  object-fit: contain;
  background: #fff;
`;
